import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import { Link } from "@randajan/jet-react/dom/link";

import "./ShopCat404.scss";

export const ShopCat404 = (props)=>{
    const {} = props;
    
    return (
        <Block className="ShopCat404" caption="Kategorie neexistuje">
            <span>Bohužel jsi někde asi špatně odbočil :(</span>
            <Link to="/">{"Pokračuj zde"}</Link>
        </Block>
    )
}

